
export const AuthPagament = ({ auth, handleChange, error }) => {

    return (<>
        <div className="row">
            <div className="col col-12 ">
                <h4>
                    Pagament d'imports
                </h4>
                <p>
                    El pagament dels imports corresponents a les taxes, materials, sortides i menús és obligatori per poder seguir el curs amb normalitat.
                    En conseqüència, no s'acceptarà cap matrícula si no s'ha formalitzat el pagament dins dels terminis establerts.
                    Així mateix, serà imprescindible presentar tota la documentació requerida perquè la matrícula pugui ser validada.
                </p>

                <p>
                    <input type="checkbox" id="authPagament" name="authPagament" value={auth} checked={auth === "1" ? true : false} onChange={(t) => { handleChange(t.target.value) }} required />
                    <label htmlFor="authPagament"> Em declaro assabentat </label>
                    <span id="auhtPagament_ERROR" className="a-Form-error">{error}</span>
                </p>

            </div>
        </div>

        <br />
    </>)

}